<template>
    <div class="py-4 container-fluid">      
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row mb-5">
                        <div class="col-lg-3">
                            <edit-death-side-nav />
                        </div>
                        <div class="col-lg-9 mt-lg-0 mt-4">
                            <death-detail />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row"></div>
        </div>
    </div>        
</template>
<script>
import EditDeathSideNav from "./components/EditDeathSideNav.vue"
import DeathDetail from "./components/DeathDetail.vue"

export default {
    name: 'AnimalDeath_edit_page',
    components: {
        EditDeathSideNav,
        DeathDetail
    },
    data() {
        return {
            Id: '',
            animal: [],
            gets: []
        }
    },
    async mounted() {        
    },
}
</script>